import { render, staticRenderFns } from "./FloatWindow.vue?vue&type=template&id=6dd31005&scoped=true"
import script from "./FloatWindow.vue?vue&type=script&lang=js"
export * from "./FloatWindow.vue?vue&type=script&lang=js"
import style0 from "./FloatWindow.vue?vue&type=style&index=0&id=6dd31005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd31005",
  null
  
)

export default component.exports